import * as React from 'react';

import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';

export interface ConvertHouseholdTypeDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => void;
    isPending: boolean;
    direction: 'toClient' | 'toProspect';
    householdName: string;
}

export const ConvertHouseholdTypeDialog = ({
    open,
    onOpenChange,
    onConfirm,
    isPending,
    direction,
    householdName,
}: ConvertHouseholdTypeDialogProps) => {
    const isToClient = direction === 'toClient';
    const title = isToClient ? 'Convert to Client' : 'Convert to Prospect';
    const description = isToClient
        ? `Are you sure you want to convert "${householdName}" from a Prospect to a Client?`
        : `Are you sure you want to convert "${householdName}" from a Client to a Prospect?`;
    const confirmLabel = isToClient ? 'Convert to Client' : 'Convert to Prospect';

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription>{description}</DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isPending}>
                        Cancel
                    </Button>
                    <Button onClick={onConfirm} disabled={isPending}>
                        {isPending ? 'Converting...' : confirmLabel}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
